/* eslint-disable no-underscore-dangle */
import React from 'react';
import { SbEditableContent } from 'storyblok-react';
import { blokToComponent } from '../../../../helpers';
import { Props } from '../../../../types';

type PageProps = Props<{ body: SbEditableContent[] }>;

export const WideImage = ({ blok, getComponent }: PageProps) => {
  if (!blok.image?.filename) return <></>;

  const image = {
    _uid: `${blok._uid}-image`,
    component: 'roche-image',
    ratio: '2.56:1',
    src: blok.image?.filename,
  };

  return blokToComponent({
    blok: {
      _uid: `${blok._uid}-wide-image-grid`,
      component: 'roche-grid-12',
      remove_padding_top: blok.downloads?.length > 0,
      slotted: [image],
    },
    getComponent,
  });
};
